<template>
  <div class="container">
    <el-row>
      <el-col>
        <el-form :inline="true" size="small">
          <el-form-item label="组织" v-if="$store.state.isAreaManager">
            <el-select v-model="listQuery.StrOrganizationID" placeholder="请选择" @change="getSWList">
              <el-option
                  v-for="item in OrganizationList"
                  :key="item.StrID"
                  :label="item.StrName"
                  :value="item.StrID"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="书屋">
            <el-select v-model="listQuery.StrLibraryID" placeholder="请选择" @change="query">
              <el-option
                  v-for="item in swList"
                  :key="item.StrID"
                  :label="item.StrName"
                  :value="item.StrID"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="查询分类方式">
            <el-select v-model="listQuery.IsCLC" placeholder="请选择"  @change="onCategoryChange">
              <el-option label="中图法" value="中图法"/>
              <el-option label="五大类" value="五大类"/>
<!--              <el-option label="自定义分类" value="自定义分类"/>-->
            </el-select>
          </el-form-item>
<!--          <el-form-item label="分类名">-->
<!--            <el-input v-model="listQuery.StrTypeName" placeholder="请输入分类" style="width: 200px"/>-->
<!--          </el-form-item>-->
          <el-form-item>
            <el-config-provider :locale="zhCn">
            <el-date-picker
                v-model="listQuery.DTStartTime"
                type="date"
                placeholder="开始时间"
                value-format="YYYY-MM-DD"
                :disabled-date="disabledDate"
                @change = "choose"
            />
            </el-config-provider>
          </el-form-item>
          <el-form-item>
            <el-config-provider :locale="zhCn">
            <el-date-picker
                v-model="listQuery.DTEndTime"
                type="date"
                placeholder="结束时间"
                value-format="YYYY-MM-DD"
                :disabled-date="disabledDate"
                @change = "choose"
            />
            </el-config-provider>
          </el-form-item>
          <el-form-item>
            <el-button
                class="filter-item"
                type="primary"
                icon="el-icon-search"
                size="mini"
                @click="query"
            >查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button
                class="filter-item"
                type="primary"
                icon="el-icon-search"
                size="mini"
                @click="reset"
            >重置</el-button>
          </el-form-item>
           <el-form-item>
        <el-button
            class="filter-item"
            type="info"
            icon="el-icon-download"
            size="mini"
            @click="handleDownload"
        >导出</el-button>
      </el-form-item>

        </el-form>
      </el-col>
    </el-row>
    <el-table
        v-loading="listLoading"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%;"
    >
      <el-table-column label="图书分类" align="center">
        <template v-slot="{row}">
          <span>{{ row.StrBookTypeName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="分类名称" align="center">
        <template v-slot="{row}">
          <span>{{ row.StrBookTypeZH }}</span>
        </template>
      </el-table-column>
      <el-table-column label="图书种数" align="center">
        <template v-slot="{row}">
          <span>{{ row.TotalISBN }}种</span>
        </template>
      </el-table-column>
      <el-table-column label="图书册数" align="center">
        <template v-slot="{row}">
          <span>{{ row.TotalCount }}册</span>
        </template>
      </el-table-column>
      <el-table-column label="百分比" align="center">
        <template v-slot="{row}">
          <span>{{row.Percentage }}%</span>
        </template>
      </el-table-column>
      <el-table-column label="总金额" align="center">
        <template v-slot="{row}">
          <span>{{ row.CostCount }}元</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {ElMessage} from "element-plus";
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import {BASE_URL} from "@/utils/constants";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
export default {
  name:'ClassifiedStatistics',
  computed: {
    zhCn() {
      return zhCn
    }
  },
  data() {
    return {
      isFive:false,
      back:null,
      list: null,
      listLoading: true,
      listQuery: {
        IsCLC:"中图法"
      },
      libraryQuery: {
        Page: 1,
        Perpage: 999,
        Sort:"-1",
        OrderBy: "DTCreatedDate",
        Search:{}
      },
      total: 0,
      swList: [],
      Url: ''
    }
  },
  created() {
    //刷新是否是区域管理员
    this.$store.commit('changeIsAreaManager');
    if (!this.$store.state.isAreaManager){ this.getSWList()}else { this.getorglist()}
    this.getList()
    this.getList1()
  },
  watch: {

  },
  methods: {
      disabledDate (time)  {
          return time.getTime() > Date.now()
      },
      choose(){
          const day1 = new Date(this.listQuery.DTStartTime)
          const day2 = new Date(this.listQuery.DTEndTime)
          if (day2.getTime() < day1.getTime()){
              ElMessage.error('日期选择错误')
              this.listQuery.DTEndTime = ''
          }
      },

    query()
    {
      if(this.isFive){
        this.onCategoryChange('五大类')
      }else {
        this.getList()
      }
    },
    onCategoryChange(value) {
      console.log("查询分类方式已更改为:", value);
      this.getList1()
      if(value === '五大类') {
        this.isFive = true;
        // 保留原始数据
        this.list = this.back;

        // 定义5个分类的初始值
        const aggregated = {
          A: { StrBookTypeName: "A", StrBookTypeZH: "马克思列毛泽东邓小平", TotalISBN: 0, TotalCount: 0, CostCount: 0 },
          B: { StrBookTypeName: "B", StrBookTypeZH: "哲学", TotalISBN: 0, TotalCount: 0, CostCount: 0 },
          "C-K": { StrBookTypeName: "C-K", StrBookTypeZH: "社科类", TotalISBN: 0, TotalCount: 0, CostCount: 0 },
          "N-X": { StrBookTypeName: "N-X", StrBookTypeZH: "自科类", TotalISBN: 0, TotalCount: 0, CostCount: 0 },
          Z: { StrBookTypeName: "Z", StrBookTypeZH: "综合性图书", TotalISBN: 0, TotalCount: 0, CostCount: 0 }
        };


        // 遍历原始数据，更新分类数据
        this.list.forEach(item => {
          if (!item.StrBookTypeName) return;

          const letter = item.StrBookTypeName.trim().toUpperCase();
          if (letter === "A") {
            aggregated.A.TotalISBN += Number(item.TotalISBN);
            aggregated.A.TotalCount += Number(item.TotalCount);
            aggregated.A.CostCount += Number(item.CostCount);
          } else if (letter === "B") {
            aggregated.B.TotalISBN += Number(item.TotalISBN);
            aggregated.B.TotalCount += Number(item.TotalCount);
            aggregated.B.CostCount += Number(item.CostCount);
          } else if (letter >= "C" && letter <= "K") {
            aggregated["C-K"].TotalISBN += Number(item.TotalISBN);
            aggregated["C-K"].TotalCount += Number(item.TotalCount);
            aggregated["C-K"].CostCount += Number(item.CostCount);
          } else if (letter >= "N" && letter <= "X") {
            aggregated["N-X"].TotalISBN += Number(item.TotalISBN);
            aggregated["N-X"].TotalCount += Number(item.TotalCount);
            aggregated["N-X"].CostCount += Number(item.CostCount);
          } else if (letter === "Z") {
            aggregated.Z.TotalISBN += Number(item.TotalISBN);
            aggregated.Z.TotalCount += Number(item.TotalCount);
            aggregated.Z.CostCount += Number(item.CostCount);
          }
        });

        // 计算所有分类的总册数
        const totalCountAll = Object.values(aggregated).reduce((sum, cat) => sum + cat.TotalCount, 0);

        // 为每个分类计算百分比，并保留 CostCount 的两位小数
        Object.values(aggregated).forEach(cat => {
          cat.Percentage = totalCountAll > 0 ? ((cat.TotalCount / totalCountAll) * 100).toFixed(2) : "0.00";
          cat.CostCount = Number(cat.CostCount.toFixed(2));
        });

        // 将对象转换成数组
        const aggregatedArray = Object.values(aggregated);

        // 计算总计数据
        const totalISBN = aggregatedArray.reduce((sum, cat) => sum + cat.TotalISBN, 0);
        const totalCount = aggregatedArray.reduce((sum, cat) => sum + cat.TotalCount, 0);
        let totalCostCount = aggregatedArray.reduce((sum, cat) => sum + cat.CostCount, 0);
        totalCostCount = Number(totalCostCount.toFixed(2));

        // 添加一个总计行
        aggregatedArray.push({
          StrBookTypeName: "总计",
          StrBookTypeZH: "总计",
          TotalISBN: totalISBN,
          TotalCount: totalCount,
          CostCount: totalCostCount,
          Percentage: totalCountAll > 0 ? "100.00" : "0.00"
        });
        // 更新 list 数据
        this.list = aggregatedArray;

      } else{
        this.isFive = false;
        this.getList(); // 获取非五大类的数据
      }
    },

    getList() {
      this.listLoading = true;
      const search = {};

      // 只在条件非空且非 undefined 时添加参数
      if (this.listQuery.IsCLC !== undefined && this.listQuery.IsCLC !== '') {
        search.IsCLC = this.listQuery.IsCLC === "中图法";
      }
      if (this.listQuery.StrLibraryID !== undefined && this.listQuery.StrLibraryID !== '') {
        search.StrLibraryID = this.listQuery.StrLibraryID;
      }
      if (this.listQuery.StrOrganizationID !== undefined && this.listQuery.StrOrganizationID !== '') {
        search.StrOrganizationID = this.listQuery.StrOrganizationID;
      }

      // 处理日期范围，只在非空且非 undefined 时添加
      var end = this.listQuery.DTEndTime;
      if (end !== undefined && end !== null && end !== '') {
        if (this.listQuery.DTStartTime !== undefined && this.listQuery.DTStartTime !== '') {
          search.DTStartTime = this.listQuery.DTStartTime + "T00:00:00.999Z";
        }
        search.DTEndTime = this.listQuery.DTEndTime + "T23:59:59.999Z";
      }

      this.$axios({
        url: BASE_URL + 'organizations/booktypescount',
        method: 'post',
        data: JSON.stringify(search),
        // 发送格式为 json
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.ok) {
          this.list = [];
          this.list = res.data.msg;
          // 计算总册数
          if (!Array.isArray(this.list)) {
            console.error('this.list 不是数组:', this.list);
            this.list = []; // 确保后续逻辑不出错
          }
          const totalBooks = this.list.reduce((sum, item) => sum + item.TotalCount, 0);
          const total = totalBooks;
          for (var i = 0; i < this.list.length; i++) {
            var cost = this.list[i].CostCount;
            let point = String(cost).length - (String(cost).indexOf('.') + 1);
            // 带有小数且超过两位小数
            if (String(cost).indexOf('.') !== -1 && point > 2) {
              this.list[i].CostCount = cost.toFixed(2);
            }
            // 计算百分比
            this.list[i].Percentage = totalBooks > 0 ? ((this.list[i].TotalCount / total * 2) * 100).toFixed(2) : "0.00";
          }
          this.listLoading = false;
        } else {
          this.listLoading = false;
        }
      });
    },

    getList1() {
      const search = {};

      // 只在条件非空且非 undefined 时添加参数
      if (this.listQuery.IsCLC !== undefined && this.listQuery.IsCLC !== '' && this.listQuery.IsCLC !== null) {
        search.IsCLC = true; // 假设 IsCLC 始终为 true，如果需要动态值，请说明
      }
      if (this.listQuery.StrLibraryID !== undefined && this.listQuery.StrLibraryID !== '' && this.listQuery.StrLibraryID !== null) {
        search.StrLibraryID = this.listQuery.StrLibraryID;
      }
      if (this.listQuery.StrOrganizationID !== undefined && this.listQuery.StrOrganizationID !== '' && this.listQuery.StrOrganizationID !== null) {
        search.StrOrganizationID = this.listQuery.StrOrganizationID;
      }

      // 处理日期范围，确保时间参数非空且有效
      var end = this.listQuery.DTEndTime;
      if (end !== undefined && end !== null && end !== '' && end !== 'null') {
        var start = this.listQuery.DTStartTime;
        if (start !== undefined && start !== null && start !== '' && start !== 'null') {
          search.DTStartTime = this.listQuery.DTStartTime + "T00:00:00.999Z";
        }
        search.DTEndTime = this.listQuery.DTEndTime + "T23:59:59.999Z";
      }

      this.$axios({
        url: BASE_URL + 'organizations/booktypescount',
        method: 'post',
        data: JSON.stringify(search),
        // 发送格式为 json
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.ok) {
          this.back = res.data.msg;
        }
      });
    },
    //重置
    reset(){
        if(this.isFive)
        {
          this.onCategoryChange('五大类')
        }else {
          this.listQuery={
            IsCLC:"中图法"
          }
          this.getList();
        }
    },
    // 获取书屋
    getSWList() {
      if (!this.$store.state.isAreaManager){
        //普通管理员
        this.$axios({
          url: BASE_URL + 'librarys',
          method: 'get',
          //发送格式为json
          headers:
              {
                'Content-Type': 'application/json',
                'dataType': 'json',
                'Authorization': localStorage.getItem("token")
              }
        }).then(res => {
          if (res.data.ok) {
            this.swList = res.data.msg
          }
        })
      }else{
        //区域管理员
        this.libraryQuery.Search.StrOrganizationID=this.listQuery.StrOrganizationID
        this.$axios({
          url: BASE_URL + 'librarys/search',
          method: 'post',
          data: JSON.stringify(this.libraryQuery),
          //发送格式为json
          headers:
              {
                'Content-Type': 'application/json',
                'dataType': 'json',
                'Authorization': localStorage.getItem("token")
              }
        }).then(res => {
          if (res.data.ok) {
            this.swList = res.data.msg
          }
        })
      }

    },
    handleDownload() {
  console.time('download');
  console.log('0-当前list数据:', this.list);

  // 1. 检查是否有数据可导出
  if (!this.list || !this.list.length) {
    console.warn('1-list为空，无法导出');
    ElMessage.warning('没有数据可供导出');
    return;
  }

  // 2. 映射数据结构以适应Excel列标题
  const data = this.list.map((item, index) => {
    console.log(`2-第${index}行原数据:`, item);
    return {
      图书分类: item.StrBookTypeName ?? '',
      分类名称: item.StrBookTypeZH ?? '',
      图书种数: (item.TotalISBN ?? 0) + '种',
      图书册数: (item.TotalCount ?? 0) + '册',
      百分比: (item.Percentage ?? 0) + '%',
      总金额: (item.CostCount ?? 0) + '元'
    };
  });
  console.log('3-映射后data:', data);

  try {
    // 3. 创建工作表和工作簿
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, '图书分类统计');
    console.log('4-工作簿生成成功');

    // 4. 导出文件
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    console.log('5-二进制数据大小:', wbout.byteLength, '字节');
    const blob = new Blob([wbout], { type: 'application/octet-stream' });
    saveAs(blob, '图书分类统计.xlsx');
    console.log('6-已调用saveAs');
    ElMessage.success('导出成功');
  } catch (error) {
    console.error('导出过程中发生错误:', error);
    ElMessage.error('导出失败: ' + error.message);
  }

  console.timeEnd('download');
},
    //获取学校
    getorglist(){
      this.$axios({
        url: BASE_URL + 'organizations/search',
        method: 'post',
        data: JSON.stringify(this.listQuery),
        //发送格式为json
        headers:
            {
              'Content-Type': 'application/json',
              'dataType': 'json',
              'Authorization': localStorage.getItem("token")
            }
      }).then(res => {
        if (res.data.ok) {
          this.OrganizationList = res.data.msg
        }
      })
    },
    // 分页
    pageSizeChange(Perpage) {
      this.listQuery.Perpage = Perpage
      this.getList()
    },
    currPageChange(Page) {
      this.listQuery.Page = Page
      this.getList()
    }
  }
}
</script>

